export default {
  name: 'error-layout'
}



// WEBPACK FOOTER //
// ./src/layouts/error/script.js